import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import ProfileNextPremierOrderSection from '/component/partial/profile/ProfileNextPremierOrderSection';
import {withTranslation} from '/provider/TranslationProvider';
import {
  hasScheduledPremierOrderById,
  nextPremierOrderAutoShipStatusById,
  nextPremierOrderCurrencyCodeById,
  nextPremierOrderCvById,
  nextPremierOrderQvById,
  nextPremierOrderScheduledOnById,
  nextPremierOrderTotalById,
} from '/redux/selector/client.selector';
import {withHOC} from '/util/hoc.util';

export default withHOC(
  connect(
    createStructuredSelector({
      hasScheduledOrder: hasScheduledPremierOrderById,
      orderScheduledOn: nextPremierOrderScheduledOnById,
      orderCv: nextPremierOrderCvById,
      orderQv: nextPremierOrderQvById,
      orderTotal: nextPremierOrderTotalById,
      orderCurrencyCode: nextPremierOrderCurrencyCodeById,
      autoShipStatus: nextPremierOrderAutoShipStatusById,
    }),
  ),
  withTranslation('screen.clientProfile.section.nextPremierOrder'),
)(ProfileNextPremierOrderSection);
